import React, { Component } from "react";

import Container from '@material-ui/core/Container';

import CanvasDraw from "react-canvas-draw";
import Button from '@material-ui/core/Button';
import { downloadPDF } from '../../utils/Utils'

class SignatureScreen extends Component {

    constructor(props) {
        super(props)
        this.state = {
            width: 0, height: 0
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }
    
    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }
    
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight })
    }

    async saveData() {
        console.log('canvas',this.canvas)
        const data = await this.canvas.getSaveData()
        //console.log(data)
    }

    clear() {
        this.canvas.clear()
    }

    render() {
        // console.log(this.canvas)
        return (
            <Container maxWidth={false}>
                <CanvasDraw
                    ref={ref => this.canvas = ref}
                    gridColor={'#FFFFFF00'}
                    lazyRadius={0}
                    brushRadius={4}
                    brushColor={"#000"}
                    canvasWidth={this.state.width}
                    canvasHeight={this.state.height}
                />
                <Button variant="contained" onClick={() => this.saveData()}>
                    Salvar
                </Button>
                <Button variant="contained" onClick={() => this.clear()}>
                    Limpar
                </Button>
            </Container>
        )
    }
}

export default SignatureScreen